interface DiagnosisCodeSnapshot {
  cptCode?: string | null;
  icdCode?: string | null;
  icdCodes?: Array<string | null | undefined> | null;
}

export interface SignedVersionCodeDisplays {
  cptCodes: string[];
  icdCodes: string[];
}

/**
 * A versioned/headless render must override current document-view diagnosis
 * codes with the codes in CaseSignOffHistory. Preserve duplicate CPTs for
 * quantity aggregation; ICD deduplication remains the report formatter's job.
 */
export function deriveSignedVersionCodeDisplays(
  diagnoses: DiagnosisCodeSnapshot[] | null | undefined,
  reportVersion: number | undefined
): SignedVersionCodeDisplays | null {
  if (reportVersion === undefined) return null;
  const rows = diagnoses || [];
  return {
    cptCodes: rows
      .map((diagnosis) => diagnosis.cptCode?.trim())
      .filter((code): code is string => Boolean(code)),
    icdCodes: rows
      .flatMap((diagnosis) =>
        diagnosis.icdCodes?.length ? diagnosis.icdCodes : [diagnosis.icdCode]
      )
      .map((code) => code?.trim())
      .filter((code): code is string => Boolean(code)),
  };
}
